import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { ReactComponent as WalletIcon } from '../assets/images/icons/wallet-20px.svg';
import { ReactComponent as ListIcon } from '../assets/images/icons/list-20px.svg';
import { ReactComponent as TruckFastIcon } from '../assets/images/icons/truck-fast.svg';
import { ReactComponent as CartShoppingIcon } from '../assets/images/icons/cart-shopping-20px.svg';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { filledInputClasses } from '@mui/material';
import { red } from '@mui/material/colors';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 13,
    margin: "0 6px",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#6100FF'
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#6100FF'
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    backgroundColor: "#16161D",
    width: 36,
    height: 6,
    border: 0,
    borderRadius: 1,
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.45)",
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: "#16161D",
  zIndex: 1,
  color: "#fff",
  width: 32,
  height: 32,
  display: "flex",
  borderRadius: "4px",
  justifyContent: "center",
  alignItems: "center",
  "& svg": {
    width: 20,
    height: 20
  },
  "& path": {
    fill: "#434356",
  },
  ...(ownerState.active && {
    border: "1px solid var(--primary-border, #A073FF)",
    backgroundColor: "#16161D",
    "& path": {
      fill: "#C5C5D3",
    },
  }),
  ...(ownerState.completed && {
    backgroundColor: "#6100FF",
    fill: red,
    
    "& path": {
      fill: "#C5C5D3",
    },
  }),

  "& img": {
    maxWidth: "20px",
    maxHeight: "20px",
  },
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <WalletIcon/>,
    2: <ListIcon/>,
    3: <TruckFastIcon/>,
    4: <CartShoppingIcon/>,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = [
  "Connect wallet",
  "Quiz",
  "Shipping information",
  "Confirmation checkout",
];

export default function OrderStepper({ currentStepNumber }) {
  return (
    <Stack sx={{ width: "100%" }} spacing={0}>
      <Stepper
        alternativeLabel
        activeStep={currentStepNumber - 1}
        connector={<ColorlibConnector />}
      >
        {steps.map((index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}
